function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { useState } from 'react';
import { Provider as QuestionProvider } from '../context/question';
import { useQuestion } from '../hooks/useQuestion';
import Avatar from './Avatar';
import QuestionForm from './QuestionForm';
import Reply from './Reply';

var getBadge = function getBadge(questionAuthorId, replyAuthorId, replyAuthorRole) {
  if (replyAuthorRole === 'admin' || replyAuthorRole === 'moderator') {
    return 'Moderator';
  }

  if (!questionAuthorId || !replyAuthorId) {
    return null;
  }

  return questionAuthorId === replyAuthorId ? 'Author' : null;
};

var Collapsed = function Collapsed(_ref) {
  var _reply$profile, _reply$profile2;

  var setExpanded = _ref.setExpanded;

  var _useQuestion = useQuestion(),
      replies = _useQuestion.replies,
      resolvedBy = _useQuestion.resolvedBy,
      questionAuthorId = _useQuestion.questionAuthorId;

  var reply = replies[replies.findIndex(function (reply) {
    return (reply === null || reply === void 0 ? void 0 : reply.id) === resolvedBy;
  })] || replies[replies.length - 1];
  var replyCount = replies.length - 2;
  var maxAvatars = Math.min(replyCount, 3);
  var replyAuthorMetadata = reply === null || reply === void 0 ? void 0 : (_reply$profile = reply.profile) === null || _reply$profile === void 0 ? void 0 : _reply$profile.metadata[0];
  var badgeText = getBadge(questionAuthorId, reply === null || reply === void 0 ? void 0 : (_reply$profile2 = reply.profile) === null || _reply$profile2 === void 0 ? void 0 : _reply$profile2.id, replyAuthorMetadata === null || replyAuthorMetadata === void 0 ? void 0 : replyAuthorMetadata.role);
  var avatars = [];

  for (var _iterator = _createForOfIteratorHelperLoose(replies.slice(1)), _step; !(_step = _iterator()).done;) {
    var _reply$profile3;

    var _reply = _step.value;
    if (avatars.length >= maxAvatars) break;
    var avatar = _reply === null || _reply === void 0 ? void 0 : (_reply$profile3 = _reply.profile) === null || _reply$profile3 === void 0 ? void 0 : _reply$profile3.avatar;

    if (avatar && !avatars.includes(avatar)) {
      avatars.push(avatar);
    }
  }

  if (avatars.length < maxAvatars) {
    avatars.push.apply(avatars, Array(maxAvatars - avatars.length));
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("div", {
    className: "squeak-other-replies-container"
  }, avatars.map(function (avatar) {
    return /*#__PURE__*/React.createElement(Avatar, {
      image: avatar
    });
  }), /*#__PURE__*/React.createElement("button", {
    className: "squeak-other-replies",
    onClick: function onClick() {
      return setExpanded(true);
    }
  }, "View ", replyCount, " other ", replyCount === 1 ? 'reply' : 'replies'))), /*#__PURE__*/React.createElement("li", {
    key: reply === null || reply === void 0 ? void 0 : reply.id,
    className: (resolvedBy === (reply === null || reply === void 0 ? void 0 : reply.id) ? 'squeak-solution' : '') + " " + (!(reply === null || reply === void 0 ? void 0 : reply.published) ? 'squeak-reply-unpublished' : '')
  }, /*#__PURE__*/React.createElement(Reply, _extends({
    className: "squeak-post-reply"
  }, reply, {
    badgeText: badgeText
  }))));
};

var Expanded = function Expanded(_ref2) {
  var _question$replies;

  _objectDestructuringEmpty(_ref2);

  var question = useQuestion();
  var replies = (_question$replies = question.replies) === null || _question$replies === void 0 ? void 0 : _question$replies.slice(1);
  var resolvedBy = question.resolvedBy,
      questionAuthorId = question.questionAuthorId;
  return replies.map(function (reply) {
    var _reply$profile4, _reply$profile5;

    var replyAuthorMetadata = reply === null || reply === void 0 ? void 0 : (_reply$profile4 = reply.profile) === null || _reply$profile4 === void 0 ? void 0 : _reply$profile4.metadata[0];
    var badgeText = getBadge(questionAuthorId, reply === null || reply === void 0 ? void 0 : (_reply$profile5 = reply.profile) === null || _reply$profile5 === void 0 ? void 0 : _reply$profile5.id, replyAuthorMetadata === null || replyAuthorMetadata === void 0 ? void 0 : replyAuthorMetadata.role);
    return /*#__PURE__*/React.createElement("li", {
      key: reply.id,
      className: (resolvedBy === reply.id ? 'squeak-solution' : '') + " " + (!reply.published ? 'squeak-reply-unpublished' : '')
    }, /*#__PURE__*/React.createElement(Reply, _extends({
      className: "squeak-post-reply"
    }, reply, {
      badgeText: badgeText
    })));
  });
};

var Replies = function Replies(_ref3) {
  var expanded = _ref3.expanded,
      setExpanded = _ref3.setExpanded;

  var _useQuestion2 = useQuestion(),
      resolved = _useQuestion2.resolved,
      replies = _useQuestion2.replies,
      onSubmit = _useQuestion2.onSubmit,
      question = _useQuestion2.question;

  return /*#__PURE__*/React.createElement(React.Fragment, null, replies && replies.length - 1 > 0 && /*#__PURE__*/React.createElement("ul", {
    className: "squeak-replies " + (resolved ? 'squeak-thread-resolved' : '')
  }, expanded || replies.length <= 2 ? /*#__PURE__*/React.createElement(Expanded, null) : /*#__PURE__*/React.createElement(Collapsed, {
    setExpanded: setExpanded
  })), resolved ? /*#__PURE__*/React.createElement("div", {
    className: "squeak-locked-message"
  }, /*#__PURE__*/React.createElement("p", null, "This thread has been closed")) : /*#__PURE__*/React.createElement("div", {
    className: "squeak-reply-form-container"
  }, /*#__PURE__*/React.createElement(QuestionForm, {
    onSubmit: onSubmit,
    messageID: question.id,
    formType: "reply"
  })));
};

export default function Question(_ref4) {
  var question = _ref4.question,
      onSubmit = _ref4.onSubmit,
      onResolve = _ref4.onResolve,
      replies = _ref4.replies;

  var _useState = useState(false),
      expanded = _useState[0],
      setExpanded = _useState[1];

  var firstReply = replies[0];
  return /*#__PURE__*/React.createElement("div", {
    className: "squeak-question-container"
  }, /*#__PURE__*/React.createElement(Reply, _extends({
    className: "squeak-post",
    subject: question.subject
  }, firstReply)), /*#__PURE__*/React.createElement(QuestionProvider, {
    onSubmit: onSubmit,
    question: question,
    replies: replies,
    onResolve: onResolve
  }, /*#__PURE__*/React.createElement(Replies, {
    expanded: expanded,
    setExpanded: setExpanded
  })));
}